// @ts-nocheck
import FieldDefinition, {
    ExcludeFromNavigation,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";

const FolderPage = () => null;

const pageModule: PageModule = {
    component: FolderPage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        fieldDefinitions: [
            { ...HideHeader, defaultValue: true, isVisible: x => false },
            { ...HideFooter, defaultValue: true, isVisible: x => false },
            { ...HideFromSearchEngines, defaultValue: true, isVisible: x => false },
            { ...HideFromSiteSearch, defaultValue: true, isVisible: x => false },
            { ...ExcludeFromNavigation, defaultValue: true, isVisible: x => false },
        ] as FieldDefinition[],
    },
};

export default pageModule;
